import React from 'react';
import './ConfirmInformationStep.scss';
import UtilsFunctions from "../../../../utils/UtilsFunctions";

const ConfirmInformationStep = ({ sendData }) => {

  try {
    return (
      <div className={"ConfirmInformationStep"}>

        <div className={"c-row"}>
          <div className={"singe-row"} style={{ columnGap: "30px" }}>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
            <h5>نوع بیمه :</h5>
            <h6>{sendData?.typeName}</h6>
            </div>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
              <h5>شماره بیمه نامه :</h5>
              <h6>{sendData?.insuranceNumber}</h6>
            </div>
          </div>

          <ul className={"grid-list"}>
            {sendData?.customerInstallmentDetails.length > 0 && sendData?.customerInstallmentDetails.map((item, index) =>
              <li key={index + "J"}>
                <div className={"inline-text"}>
                  <h5>{item?.caption + " " + (index + 1)}</h5>
                  <h5>تاریخ :</h5>
                  <h6>{item?.date}</h6>
                </div>
                <div className={"inline-text"}>
                  <h5>مبلغ :</h5>
                  <h6>{UtilsFunctions.addCommas(item?.price)}</h6>
                </div>
              </li>
            )}
          </ul>

        </div>

        <div className={"c-row"}>
          <div className={"singe-row"}>
            <span className={"color-box"}></span>
            <h4>اطلاعات شخص</h4>
          </div>
          <div className={"singe-row"}>
            <div className={"singe-row"}>
              <h5>نام و نام خانوادگی :</h5>
              <h6>{sendData?.fullName}</h6>
            </div>
            <div className={"singe-row"}>
              <h5>کد ملی :</h5>
              <h6>{sendData?.nationalId}</h6>
            </div>
            <div className={"singe-row"}>
              <h5>شماره تماس :</h5>
              <h6>{sendData?.mobile}</h6>
            </div>
            <div className={"singe-row"}>
              <h5>کد پستی :</h5>
              <h6>{sendData?.postalCode}</h6>
            </div>
            <div className={"singe-row"}>
              <h5>آدرس :</h5>
              <h6>{sendData?.address}</h6>
            </div>
          </div>

        </div>

        <div className={"c-row"}>
          <div className={"singe-row"}>
            <span className={"color-box"}></span>
            <h4>اطلاعات حق بیمه سیستمی</h4>
          </div>
          <div className={"singe-row"} style={{ columnGap: "30px" }}>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
              <h5>مبلغ کل حق بیمه :</h5>
              <h6>{UtilsFunctions.addCommas(sendData?.insurancePrice)}</h6>
            </div>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
              <h5>مبلغ پیش پرداخت :</h5>
              <h6>{UtilsFunctions.addCommas(sendData?.prePayment)}</h6>
            </div>
          </div>

          <ul className={"grid-list"}>
            {sendData?.installmentDetails.length > 0 && sendData?.installmentDetails.map((item, index) =>
              <li key={index + "J"}>
                <div className={"inline-text"}>
                  <h5>{item?.caption + " " + (index + 1)}</h5>
                  <h5>تاریخ :</h5>
                  <h6>{item?.date}</h6>
                </div>
                <div className={"inline-text"}>
                  <h5>مبلغ :</h5>
                  <h6>{UtilsFunctions.addCommas(item?.price)}</h6>
                </div>
              </li>
            )}
          </ul>

        </div>

        <div className={"c-row"}>
          <div className={"singe-row"}>
            <span className={"color-box"}></span>
            <h4>اطلاعات حق بیمه مشتری</h4>
          </div>
          <div className={"singe-row"} style={{ columnGap: "30px" }}>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
              <h5>مبلغ کل حق بیمه :</h5>
              <h6>{UtilsFunctions.addCommas(sendData?.insurancePrice)}</h6>
            </div>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
              <h5>مبلغ پرداختی مشتری :</h5>
              <h6>{UtilsFunctions.addCommas(sendData?.customerPay)}</h6>
            </div>
            <div className={"singe-row"} style={{ width: "fit-content" }}>
              <h5>مبلغ پیش پرداخت :</h5>
              <h6>{UtilsFunctions.addCommas(sendData?.customerRealPay)}</h6>
            </div>
          </div>

          <ul className={"grid-list"}>
            {sendData?.customerInstallmentDetails.length > 0 && sendData?.customerInstallmentDetails.map((item, index) =>
              <li key={index + "J"}>
                <div className={"inline-text"}>
                  <h5>{item?.caption + " " + (index + 1)}</h5>
                  <h5>تاریخ :</h5>
                  <h6>{item?.date}</h6>
                </div>
                <div className={"inline-text"}>
                  <h5>مبلغ :</h5>
                  <h6>{UtilsFunctions.addCommas(item?.price)}</h6>
                </div>
              </li>
            )}
          </ul>

        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ConfirmInformationStep;